(function () {
    function isInternetExplorer() {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
        if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./))
        {
            return true;
        }
        return false;
    }
    if ('onhashchange' in window && !isInternetExplorer()) {
        if (window.addEventListener) {
            window.addHashChange = function (func, before) {
                window.addEventListener('hashchange', func, before);
            };
            window.removeHashChange = function (func) {
                window.removeEventListener('hashchange', func);
            };
            return;
        } else if (window.attachEvent) {
            window.addHashChange = function (func) {
                window.attachEvent('onhashchange', func);
            };
            window.removeHashChange = function (func) {
                window.detachEvent('onhashchange', func);
            };
            return;
        }
    }
    var hashChangeFuncs = [];
    var oldHref = location.href;
    window.addHashChange = function (func, before) {
        if (typeof func === 'function')
            hashChangeFuncs[before ? 'unshift' : 'push'](func);
    };
    window.removeHashChange = function (func) {
        for (var i = hashChangeFuncs.length - 1; i >= 0; i--)
            if (hashChangeFuncs[i] === func)
                hashChangeFuncs.splice(i, 1);
    };
    setInterval(function () {
        var newHref = location.href;
        if (oldHref !== newHref) {
            var _oldHref = oldHref;
            oldHref = newHref;
            for (var i = 0; i < hashChangeFuncs.length; i++) {
                hashChangeFuncs[i].call(window, {
                    'type': 'hashchange',
                    'newURL': newHref,
                    'oldURL': _oldHref
                });
            }
        }
    }, 100);
})();


//////////////////
// WEBPACK FOOTER
// ./Widget/polyfills/hashchange.js
// module id = 172
// module chunks = 1